<template>
    <div class="poster">
    <body id="poster">
            <!-- 登录区域 -->
            <el-form  ref="loginFormRef" :rules="loginFormRules" :model="loginForm" label-position="left" label-width="0px"  class="login-container">
                <h2 class="login_title">机器人统一管理平台</h2>
                <el-form-item prop="username">
                    <el-input v-model="loginForm.username" prefix-icon="el-icon-user" placeholder="请输入账号" type="text"></el-input>
                </el-form-item>
                <el-form-item  prop="password">
                    <el-input v-model="loginForm.password"  :type="passwordVisible"  placeholder="请输入密码">
                        <i slot="prefix" :class="icon" @click="showPass"  style=""></i>
                    </el-input>
                </el-form-item>
                <el-form-item  prop="code">
                      <el-row :gutter='15' >
                        <el-col :span="16" >
                          <el-input v-model="loginForm.code"  placeholder="请输入验证码" class="ell-input" type="text"></el-input>
                        </el-col>
                        <el-col :span="8">
                          <img id="yzm_img" style="cursor:pointer;width: 100px;height: 36px;margin: -20px 0 0 5px;border-radius: 3px;margin-top: 0px;"   @click="getVerifiCode" :src="srcs"/>
                        </el-col>
                      </el-row>
                </el-form-item>
                            <!-- 登录 -->
                <el-form-item class="btns" >
                    <el-button type="primary" @click="login" style="width:100%;margin-bottom:30px;" >登录</el-button>
                </el-form-item>
                <el-form-item class="btns" />
                <el-form-item class="btns" />
                <el-form-item class="btns" />
                <el-form-item class="btns" />
                <el-form-item class="btns" />
                <el-form-item class="btns" />
               <el-form-item class="btns" >
                   <a href="https://beian.miit.gov.cn/"  style="text-decoration:none;color:white;" target="_blank">鄂ICP备19026143号-3</a>
                </el-form-item>
            </el-form>
        </body> 
    </div>
</template>

<script>
import qs from 'qs'
export default {
  name: 'app',
  data(){
       var  checkname = (rule, value, callback) => {
            const age= /([0-9a-zA-Z]){5,12}/
            if (!age.test(value)) {
                callback(new Error('请输入长度为5到12字母或者数字！'))
            }else{
                callback()
            }
      }
      var  checkpassword = (rule, value, callback) => {
            const age= /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
            if (!age.test(value)) {
                callback(new Error('请输入长度为6到16 字母和数字！'))
            }else{
                callback()
            }
      }
      var  vcode = (rule, value, callback) => {
            const age= /([0-9a-zA-Z]){4,4}/
            if (!age.test(value)) {
                callback(new Error('请输入正确的验证码！'))
            }else{
                callback()
            }
      }
      return {
          passwordVisible:'password',
          icon:"el-icon-view",
          loginForm :{
            loginName: '',
            password: ''
          },
          loginFormRules: {
              username: [ { required: true, message: '请输入账号', trigger: 'blur' },{ min: 5, max: 12, message: '长度在 5 到 12 字母或者数字', trigger: 'blur' },{ validator : checkname, trigger: 'blur'}],
              password: [ { required: true, message: '请输密码', trigger: 'blur' }  ,{ min: 6, max: 16, message: '长度在 6 到 16 字母或者数字', trigger: 'blur' },{ validator : checkpassword, trigger: 'blur'}],
              code: [ { required: true, message: '请输入验证码', trigger: 'blur' }  ,{ min: 4, max: 4, message: '请输入正确的验证码!', trigger: 'blur' },{ validator : vcode, trigger: 'blur'}]
            },
          srcs:''
      }
  },
 created(){
          this.getVerifiCode();
  },
  methods: {
        //重置表单
        resetLoginForm(){
            // console.log(this);
            this.$refs.loginFormRef.resetFields();
        },
        showPass() {
         if( this.passwordVisible==="text"){
           this.passwordVisible="password";
           //更换图标
           this.icon="el-icon-view";
         }else {
           this.passwordVisible="text";
           this.icon="el-icon-lock";
         }
        },
        getVerifiCode(){
        var data=this.$http.defaults.baseURL+"user/getVerifiCode?a="+new Date().getTime();
          
        this.srcs =  data;

        },
           //生命周期函数
       
        login(){
            //获取校验结果，合格发送请求
            this.$refs.loginFormRef.validate( valid=>{
                if(!valid){
                    return ;
                }
                if(this.loginForm.code==undefined){
                   return this.$message.error("验证码为空!");
                }
                let params={
                  username:this.loginForm.username,
                  password:this.loginForm.password,
                  code:this.loginForm.code,
                }
                this.$http.post('/user/login',JSON.stringify(params)).then(response => {
                    if (response.data.code === 200) {
                        window.sessionStorage.setItem("sign",response.data.result.sign)

                        this.$cookies.set("role", JSON.stringify(response.data.result.role), 60 * 60 * 8) 
                        this.$cookies.set("token", response.data.result.token, 60 * 60 * 8) 
                        this.$cookies.set("sign", response.data.result.sign, 60 * 60 * 8) 
                        this.$cookies.set("user", JSON.stringify(response.data.result.user), 60 * 60 * 8) 

                        this.$store.dispatch('mqttServer')
                        this.$router.replace({path: '/welcome'})
                    }else{
                         return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

                })
           });
        }
  }
  
}
</script>

<style lang="less" scoped>

  #poster {
    //background:url("../assets/asd.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-color:#2d3a4b;
    position: fixed;
  }
  body{
    margin: 0px;
  }
  .ell-input {
    width: 100%;
  }
  .els-input {
    width: 100%;
  }
 .login-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 15% auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background:#2d3a4b;
    //border: 1px solid #eaeaea;
    //box-shadow: 0 0 25px #cac6c6;
  }
  .login_title {
    margin: 0px auto 20px auto;
    text-align: center;
    color: #fff;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color:#889aa4;
    cursor: pointer;
    user-select: none;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #889aa4;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue